import { MdOutlineDashboard,
  MdPersonAddAlt,
  MdSearch,
  MdAddCircleOutline,
  MdNotificationsNone,
  MdOutlineMail,
  MdTrendingUp,
  MdInsertChartOutlined,
  MdRocketLaunch,
  MdOutlineCalendarToday,
  MdOutlineInfo,
  MdOutlineAccessTime,
  MdOutlinePerson,
  MdOutlineSecurity,
  MdOutlineVpnKey,
  MdOutlineSettings,
  MdOutlineAutoAwesome,
  MdMenu,
  MdClose,
  MdOutlineSmartphone,
  MdSignalCellularAlt,
  MdRouter,
  MdCheckCircle,
  MdCheck,
  MdArrowBack,
  MdKeyboardArrowRight,
  MdOutlineCheckCircleOutline,
  MdCheckCircleOutline,
  MdOutlineCable,
  MdOutlineCellTower,
  MdOutlinePlace,
  MdOutlinePictureAsPdf,
  MdOutlineAdd,
  MdOutlineShoppingCart,
  MdKeyboardArrowDown,
  MdOutlineFolderOpen,
  MdOutlineDescription,
  MdOutlinePeople,
  MdOutlineUpload,
  MdStarOutline,
  MdOutlineBusiness,
  MdOutlinePermContactCalendar } from "react-icons/md";
import { LuHouse, LuFolderKanban,LuClipboardCheck ,LuSparkles,LuPanelLeftClose, LuPanelRightClose } from "react-icons/lu";
import { RiGroupLine } from "react-icons/ri";
import { LiaWrenchSolid } from "react-icons/lia";
import { TbWallet } from "react-icons/tb";
import { CgFileDocument } from "react-icons/cg";
import { RxQuestionMarkCircled } from "react-icons/rx";


export const PanelLeftIcon = LuPanelLeftClose;
export const PanelRightIcon = LuPanelRightClose;
export const QuestionMarkIcon = RxQuestionMarkCircled;
export const KIIcon = LuSparkles ;
export const DocumentIcon = CgFileDocument;
export const WalletIcon = TbWallet;
export const BoardCheckIcon = LuClipboardCheck ;
export const ServiceIcon = LiaWrenchSolid;
export const ContactsIcon = MdOutlinePermContactCalendar;
export const ProjectsIcon = LuFolderKanban;

export const HouseIcon = LuHouse;
export const TeamIcon = RiGroupLine;
export const DashboardIcon = MdOutlineDashboard;
export const NewCustomerIcon = MdPersonAddAlt;
export const SearchIcon = MdSearch;
export const NewOfferIcon = MdAddCircleOutline;
export const VVLIcon = MdNotificationsNone;
export const MailIcon = MdOutlineMail;
export const PotentialIcon = MdTrendingUp;
export const BestsellerIcon = MdInsertChartOutlined;
export const RocketIcon = MdRocketLaunch;
export const UserIcon = MdOutlinePerson;
export const SecurityIcon = MdOutlineSecurity;
export const LicenseIcon = MdOutlineVpnKey;
export const SettingsIcon = MdOutlineSettings;
export const AIIcon = MdOutlineAutoAwesome;
export const MenuIcon = MdMenu;
export const CloseIcon = MdClose;
export const CalendarIconDetail = MdOutlineCalendarToday;
export const ForecastIcon = MdTrendingUp;
export const ActivityIcon = MdOutlineAccessTime;
export const InfoIcon = MdOutlineInfo;
export const SmartphoneIcon = MdOutlineSmartphone;
export const SignalIcon = MdSignalCellularAlt;
export const RouterIcon = MdRouter;
export const SparklesIcon = MdOutlineAutoAwesome;
export const CheckCircleIcon = MdCheckCircle;
export const CheckIcon = MdCheck;
export const ArrowBackIcon = MdArrowBack;
export const ArrowRightIcon = MdKeyboardArrowRight;
export const ArrowDownIcon = MdKeyboardArrowDown;
export const MapPinIcon = MdOutlinePlace;
export const PdfIcon = MdOutlinePictureAsPdf;
export const PlusIcon = MdOutlineAdd;
export const CartIcon = MdOutlineShoppingCart;
export const CheckCircleOutlineIcon = MdOutlineCheckCircleOutline;
export const RouterIconFi = MdRouter;
export const CableIcon = MdOutlineCable;
export const DSLIcon = MdOutlineCellTower;
export const VerifiedIcon = MdCheckCircleOutline;
export const FolderIcon = MdOutlineFolderOpen;
export const DescriptionIcon = MdOutlineDescription;
export const PeopleIcon = MdOutlinePeople;
export const ImportIcon = MdOutlineUpload;
export const StarIcon = MdStarOutline;
export const BusinessIcon = MdOutlineBusiness;


